import { useMemo, useContext, ReactElement } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

import { Segment } from '../../clients';
import { UserContext } from '../userProvider';
import { getConfig } from '~/org/twilio/one-support-center/shared/osc-env';

const { splitAuthorizationKey } = getConfig();

export const ExperimentProvider = ({ children }): ReactElement => {
  const { account } = useContext(UserContext);

  // If sub-account, use parentAccountSid
  const isSubAccount = account?.parentAccountSid;
  const experimentAccountSid = isSubAccount
    ? account.parentAccountSid
    : account?.sid;

  const splitConfig = useMemo<{
    core: { authorizationKey: string; key: string };
  }>(() => {
    const anonymousId = Segment.getAnonymousUserId();

    return {
      core: {
        authorizationKey: splitAuthorizationKey,
        key: experimentAccountSid || anonymousId,
      },
    };
  }, [experimentAccountSid]);

  return (
    <SplitFactoryProvider
      config={splitConfig}
      attributes={{ unauthenticated: !experimentAccountSid }}
    >
      {children}
    </SplitFactoryProvider>
  );
};
